"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return ListViewColumn;
    }
});
let ListViewColumn = class ListViewColumn {
    static async get(..._args) {
        return null;
    }
    static async list(..._args) {
        return [];
    }
    static async insert(..._args) {
        return null;
    }
    static async update(..._args) {
        return null;
    }
    static async getNextOrderForLevel(..._args) {
        return 1;
    }
    constructor(data){
        Object.assign(this, data);
    }
};
